import React, { Component } from 'react'
import { Icon, Table } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { get_letter } from './../actions/print.action';

// Styles
import './../style.css';

class LetterPrint extends Component {

    constructor( props ){
        super( props );

        this.state = {
             data: []
        }

    }

    componentWillMount(){
        this.props.get_letter( this.props.match.params.id );
    }

    componentWillReceiveProps( nextProps ){

        console.log( nextProps );
        
        if( nextProps.print.length != 0 ){
            this.setState({
                data: nextProps.print.OUTPUT.DATA[0]
            })

            setTimeout(() => {
                window.print();
            },500)

        }

    }

    render() {
        return (
            <div className="print_wrapper letter">
                
                <table width="100%">

                    <thead>
                        <tr>
                            <th colSpan="2">
                                <span className="print_logo"></span>
                                <span className="jgroup_logo"></span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr>
                            <td  width="80%" valign="top">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <h1 className="letter_head">Letter Application Form</h1>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                
                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" height="30px"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%">Name: &nbsp;<b>{ this.state.data.full_name }</b></td>
                                            <td width="50%">Date: &nbsp;<b>{ this.state.data.request_date }</b></td>
                                        </tr>
                                        <tr>
                                            <td width="50%">Designation: &nbsp;<b>{ this.state.data.designation_name }</b></td>
                                            <td width="50%">Department: &nbsp;<b>{ this.state.data.department_name }</b></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"><b>Requesting for:</b></td>
                                        </tr>
                                        <tr>
                                            <td width="100%"></td>
                                        </tr>
                                        <tr>
                                            <td className={ ( this.state.data.requesting_for === "Salary Certificate" ) ? "request_check checked": "request_check" } 
                                                width="100%">Salary Certificate</td>
                                        </tr>
                                        <tr>
                                            <td className={ ( this.state.data.requesting_for === "Salary Transfer Letter" ) ? "request_check checked": "request_check" }
                                                width="100%">Salary Transfer Letter</td>
                                        </tr>
                                        <tr>
                                            <td className={ ( this.state.data.requesting_for === "Salary Slip" ) ? "request_check checked": "request_check" }
                                                width="100%">Salary Slip</td>
                                        </tr>
                                        <tr>
                                            <td className={ ( this.state.data.requesting_for === "NOC" ) ? "request_check checked": "request_check" }
                                                width="100%">NOC</td>
                                        </tr>
                                        <tr>
                                            <td className={ ( this.state.data.requesting_for === "Recommendation Letter" ) ? "request_check checked": "request_check" }
                                                width="100%">Recommendation Letter</td>
                                        </tr>
                                        <tr>
                                            <td className={ ( this.state.data.requesting_for === "Undertaking Letter" ) ? "request_check checked": "request_check" }
                                                width="100%">Undertaking Letter</td>
                                        </tr>
                                        <tr>
                                            <td className="request_check" width="100%">Others: ______________________________________________________________________</td>
                                        </tr>
                                        
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"><b>Addressed to (Bank/Company/Facility/Agency):</b></td>
                                        </tr>
                                        <tr>
                                            <td className="line" width="100%">
                                                { this.state.data.address_to }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"><b>Purpose:</b></td>
                                        </tr>
                                        <tr>
                                            <td className="line" width="100%">
                                                { this.state.data.purpose }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%"><b>Additional Remarks ( specific details you want to add in the letter ): </b></td>
                                        </tr>
                                        <tr>
                                            <td className="line" width="100%">
                                                { this.state.data.remarks }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="100%" style={{ height: "230px" }}></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                    </tbody>

                    <tfoot>
                        <tr>
                            <td width="100%" valign="top" colSpan={0}>

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%">Applicant: &nbsp;</td>
                                            <td width="50%">HR: &nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td width="50%">Signature: &nbsp;</td>
                                            <td width="50%">Signature: &nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                    </tfoot>

                </table>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_letter } )( LetterPrint );



// WEBPACK FOOTER //
// ./src/pages/prints/letter/index.js